// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IVV3X","col":"styles_col__2NXtA"};